if (!customElements.get('lg-multicolumn')) {
  class LgMulticolumn extends HTMLElement {
    constructor () {
      super();
      this.slider = this.querySelector('.js-multicolumn')

      window.addEventListener('resize', this.resize.bind(this))
    }

    connectedCallback () {
      setTimeout(() => {
        this.initSlider()
      }, 1000)
    }

    initSlider () {
      this.flickity = new Flickity(this.slider, {
        adaptiveHeight: false,
        autoPlay: false,
        dragThreshold: 7,
        fade: false,
        friction: 0.8,
        initialIndex: 0,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        selectedAttraction: 0.14,
        setGallerySize: true,
        wrapAround: true,
        cellAlign: 'left'
      })
    }

    resize () {
      if (this.flickity) {
        this.flickity.flickity('resize')
      }
    }
  }

  customElements.define('lg-multicolumn', LgMulticolumn)
}